// extracted by mini-css-extract-plugin
module.exports = {"DataArea":"DataCard_DataArea__2c3Os","Header":"DataCard_Header__1TCcF","Number":"DataCard_Number__2uUTP","Content":"DataCard_Content__1qaWv","Footer":"DataCard_Footer__1xdhw"};